import jssVariables from "../../jss_setup";

export const FerriesSearchStrip = {
  searchStrip: {
    background: jssVariables.colors.base_color,
    smallscreen: {
      background: jssVariables.colors.base_color,
    },
  },
  loaderIcon: {
    color: jssVariables.colors.secondary_color,
  },
  loaderText: {
    color: jssVariables.colors.secondary_color,
  },
};

export const FerriesSearchDestination = {
  icon: {
    color: jssVariables.colors.secondary_color,
  },
};

export const FerriesSearchDates = {
  icon: {
    color: jssVariables.colors.secondary_color,
  },
};

export const FerriesSearchPax = {
  icon: {
    color: jssVariables.colors.secondary_color,
  },
};

export const ferriesFiltersBar = {
  filtersBar: {
    background: "#8EA2B1",
    smallscreen: {
      color: "white",
    },
  },
};

export const FerryStyles = {
  priceTextLabel: {
    color: jssVariables.colors.secondary_color,
  },
  totalPrice: {
    color: jssVariables.colors.secondary_color,
  },
};

export const FerryDetails = {
  searchContainer: {
    background: jssVariables.colors.base_color,
  },
};
